import { Component, OnInit, ViewChild } from '@angular/core';
import { InputSwitch } from 'primeng/inputswitch';
import { Dropdown } from 'primeng/dropdown';
import { ConfirmationService, MessageService } from "primeng/api";
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-designation-management',
  templateUrl: './designation-management.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)"},
  styleUrls: ['./designation-management.component.css']
})
export class DesignationManagementComponent implements OnInit {

  allDesignationManagement: IDesignationManagement[];
  sourceAllDesignationManagement: IDesignationManagement[];
  designationManagement: IDesignationManagement;
  mode: string = 'add';
  enterSteps: any[];
  isConfirmationBox: boolean;
  currentStep: any;
  currencyDropDown: any[] = [];
  user: any;
  loading: boolean = false;
  first: number = 0;
  designationSearch: string;
  userObj: IUser;

  constructor(
    private LanguageService: LanguageService,
    private confirmationService: ConfirmationService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService
  ) { }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("DesignationManagementComponent", label);
  }
  ngOnInit(): void {
    this.userObj = new IUser();
    this.designationManagement = new IDesignationManagement();

    this.isConfirmationBox = false;
    this.currentStep = 0;
    if (this.mode == 'edit') {
        this.enterSteps = [
            "designationName",
            "designationSalary",
            "designationIs_Active",
            "designationCurrency",
            "designationAdded",
            "designationClear"
        ];
    } else if (this.mode == 'add') {
        this.enterSteps = [
          "designationName",
          "designationSalary",
          "designationIs_Active",
          "designationCurrency",
          "designationAdded",
          "designationClear"
        ];
    }

    this.currencyDropDown = [
      { label: "Select Currency", value: "null" },
      { label: "PKR", value: "PKR" }
    ];

    this.user = AuthService.getLoggedInUser();

    this.breadcrumbService.setItems([
      { label: "HR Management" },
      { label: "Designation Management" },
    ]);
    this.userObj.company = AuthService.getLoggedInCompany();
    this.userObj.branch = AuthService.getLoggedInBranch();

    this.getAllDesignation();
  }

  getAllDesignation(){
    this.appServiceManager.get(`hr/getAllDesignation/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.allDesignationManagement = this.sourceAllDesignationManagement = res;
      } else {
        this.allDesignationManagement = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  hotkeys($event) {
    if (($event.keyCode == 39 || $event.keyCode == 37) && (this.currentStep == 4 || this.currentStep == 5) && this.isConfirmationBox) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
          if (document.activeElement.tagName === "BODY") {
              confirmationBoxButtonExist[0].focus();
          }
          else {
              if (document.activeElement === confirmationBoxButtonExist[0]) {
                  confirmationBoxButtonExist[1].focus();
              }
              else if (document.activeElement === confirmationBoxButtonExist[1]) {
                  confirmationBoxButtonExist[0].focus();
              }
              else {
                  confirmationBoxButtonExist[0].focus();
              }
          }
      }
    }
    else if (($event.keyCode == 39 || $event.keyCode == 37) && this.currentStep == 2 && !this.isConfirmationBox) {
      let ele = document.getElementById("designationIs_Active").children[0] as HTMLElement;
      ele.click();
    }
    else if($event.keyCode == 13 && this.currentStep == 4 && Object.keys(this.designationManagement).length !== 0 &&  !this.isConfirmationBox){
      this.addDesignation();
    }
    else if($event.keyCode == 13 && this.currentStep == 5 && Object.keys(this.designationManagement).length !== 0 &&  !this.isConfirmationBox){
      this.clearFields();
    }
    else if ($event.keyCode == 13 && !this.isConfirmationBox) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      if(!this.allFieldsAreValid() && this.currentStep == 3){
        // this.allFieldsAreValid() return true it means fields are valid.
        nextStep = nextStep + 1;
      }
      var nextId = this.enterSteps[nextStep];
      if(nextId == "designationCurrency"){
        let ele = document.getElementById("designationCurrency").children[0] as HTMLElement;
        ele.click();
        document.getElementById("designationIs_Active").classList.remove("active");
      }
      else if(nextId == "designationIs_Active"){
        document.getElementById("designationSalary").blur();
        document.getElementById("designationIs_Active").classList.add("active");
      }
      else {
        document.getElementById("designationIs_Active").classList.remove("active");
        let ele: any = document.getElementById(nextId);
        ele.focus();
      }
      this.currentStep = nextStep;
    }
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
        this.currentStep = indexOfClickField;
    }
    else {
        this.currentStep = this.currentStep;
    }
  }

  addDesignation(){
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to add designation?",
      accept: () => {
        let designationData = this.designationManagement;
        let designationNew = {
          name              : designationData.name,
          isActive          : designationData.isActive,
          currency          : designationData.currency,
          salary            : designationData.salary,
          branch            : this.user.branch,
          company           : this.user.company,
          isDelete          : false,
          createdBy         : this.user._id,
          createdDate       : new Date()
        }
        this.appServiceManager
          .post("hr", designationNew)
          .subscribe(
              (res: any) => {
                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success Message",
                    detail: "Designation Successfully Added",
                });
                this.getAllDesignation();
                this.designationManagement = new IDesignationManagement();
                this.currentStep = 0;
                var firstId = this.enterSteps[0];
                let ele: any = document.getElementById(firstId);
                ele.focus();
                setTimeout(() => {
                  this.isConfirmationBox = false;
                },1000);
              },
              (error: any) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: "error",
                      summary: "Error Message",
                      detail: error,
                  });
              }
          );
      },
      reject: () => {
        var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
        var nextId = this.enterSteps[nextStep];
        let ele: any = document.getElementById(nextId);
        ele.focus();
        setTimeout(() => {
          this.isConfirmationBox = false;
        },1000);
      }
    });
  }

  clearFields(){
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to clear data?",
      accept: () => {
        this.designationManagement = new IDesignationManagement();
        this.currentStep = 0;
        var firstId = this.enterSteps[0];
        let ele: any = document.getElementById(firstId);
        ele.focus();
        setTimeout(() => {
          this.isConfirmationBox = false;
        },1000);
      },
      reject: () => {
        this.currentStep = 0;
        var firstId = this.enterSteps[0];
        let ele: any = document.getElementById(firstId);
        ele.focus();
        setTimeout(() => {
          this.isConfirmationBox = false;
        },1000);
      }
    });
  }

  allFieldsAreValid(){
    if(Object.keys(this.designationManagement).length === 0){
      return false;
    }
    else {
      if(this.designationManagement.name.length < 2){
        return false;
      }
      if(this.designationManagement.salary <= 0){
        return false;
      }
      if(this.designationManagement.currency == "null"){
        return false;
      }
      else{
        return true;
      }
    }
  }

  deleteDesignation(id){
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to delete designation?",
      accept: () => {

        this.appServiceManager
          .delete(`hr/${id}`)
          .subscribe(
              (res: any) => {
                this.getAllDesignation();
                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success Message",
                    detail: "Designation Successfully Deleted",
                });
              },
              (error: any) => {
                  this.messageService.clear();
                  this.messageService.add({
                      severity: "error",
                      summary: "Error Message",
                      detail: error,
                  });
              }
          );
      }
    });
  }

  resetFilter() {
    this.designationSearch = '';
      this.allDesignationManagement = this.sourceAllDesignationManagement;
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
        if (value == "" || !value) {
            this.allDesignationManagement = Object.assign([], this.sourceAllDesignationManagement);
        }
        else {
            if (type === "name") {
                matchedName = Object.assign([], this.sourceAllDesignationManagement).filter(
                    book => book.name ? book.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
            }
            const distinct = (value, index, self) => {
                return self.indexOf(value) === index;
            }
            const source = matchedName;
            this.allDesignationManagement = source.filter(distinct);

            if (this.allDesignationManagement.length === 0) {
                this.allDesignationManagement = [];
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
            } else {
                this.first = 0;
                if (this.allDesignationManagement.length === 1) {
                    this.first = 0;
                }
                this.allDesignationManagement = [...this.allDesignationManagement];
            }
        }
    } else {
        this.allDesignationManagement = Object.assign([], this.sourceAllDesignationManagement);
    }
  }

  updateAllDesignation(){
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to update Employee's Salary?",
      accept: () => {
        this.loading = true;
        let data = {
          company:this.userObj.company,
          branch:this.userObj.branch,
          modifiedBy: this.user._id,
          allDesignation:this.sourceAllDesignationManagement,
        }
        this.appServiceManager.put('hr/UpdateAllDesignation', data).subscribe((res: any) => {
          if (res.length > 0) {
            // this.users = res.filter((value: { userRole: any; }) => value.userRole.name !== "Super Admin");
            // console.log("this.users = res;",res);
            this.messageService.clear();
            this.messageService.add({
                severity: "success",
                summary: "Success Message",
                detail: "Designation Successfully Updated",
            });
            // this.getAllDesignation();
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
      },
      reject: () => {}
    });
  }

}

class IDesignationManagement {
  name              : String;
  isActive          : Boolean;
  currency          : String;
  salary            : number;
  branch            : String;
  company           : String;
  isDelete          : Boolean;
  createdBy         : String;
  createdDate       : Date;
  modifiedBy        : String;
  modifiedDate      : Date;
}